import { BackendService } from '@toro/common/shared/services/new-http/backend.service';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AdvancedPlatformsService extends BackendService {
  public getSubscriptions() {
    return this.api.get('/platform/subscriptions');
  }

  public getPlatformsList() {
    return of(platformData);
  }
}

export const enum PlatformsIds {
  ToroTraderProfit = '8f3b0d38-a3c3-4b4a-a5d4-13d2b288c726',
  ToroTraderMobile = '18897b7f-13bb-4d43-a6c3-5a6049bf04c8',
  ProfitPro = '8ec67f19-84a5-424b-afd8-19a43d1b09e3',
  HomeBrokerClassic = '8725a752-7f8d-4b7b-95f7-90d4993a0984',
  Smarttbot = '9ba9ab87-3f5b-4b1e-b2bb-c69b5cea54e8',
  TradeMap = 'f7156bf6-7094-4ff8-83ee-c14df0272ad8',
}


export const platformData: any[] = [
  {
    id: PlatformsIds.ToroTraderProfit,
    title: 'Toro Trader',
    queryParam: 'toro-profit',
    subscriptionStatus: null,
  },
  {
    id: PlatformsIds.ToroTraderMobile,
    title: 'Toro Trader Mobile',
    queryParam: 'toro-trader-mobile',
    subscriptionStatus: null,
  },
  {
    id: PlatformsIds.ProfitPro,
    title: 'Profit Pro',
    queryParam: 'profit-pro',
    subscriptionStatus: null,
  },
  {
    id: PlatformsIds.HomeBrokerClassic,
    title: 'Home Broker Clássico',
    queryParam: 'home-broker-classico',
    subscriptionStatus: null,
  },
  {
    id: PlatformsIds.Smarttbot,
    title: 'Smarttbot',
    queryParam: 'smarttbot',
    subscriptionStatus: null,
  },
  {
    id: PlatformsIds.TradeMap,
    title: 'TradeMap',
    queryParam: 'trademap',
    subscriptionStatus: null,
  }
];
